/**************************************************
 * Nombre:       Tarjeta_Profundizaciones
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, IconButton, Typography} from "@mui/material";
import foto from '../../Recursos/foto_profundizacion.png'
import {theme} from "../../Tema";
import {NEGRITA} from "../../Constantes";
import {ArrowForward} from '@mui/icons-material'


const Tarjeta_Profundizaciones = () => {

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                <img src={foto} width={'100%'} height={'auto'}/>
            </Grid>

            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'center'}
                size={{xs: 12, sm: 12, md: 10}}
                sx={{
                    backgroundColor: theme.palette.primary.main,
                    p: 3,
                    color: '#fff',
                    mt: -10
                }}
            >

                <Grid container size={{xs: 12, sm: 12, md: 10}} sx={{justifyContent: 'flex-start'}}>
                    <Typography sx={{fontFamily: NEGRITA, fontSize: 32, fontWeight: 800}}>
                        Técnicos Laborales
                    </Typography>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 2}} sx={{justifyContent: 'flex-end'}}>
                    <IconButton
                        sx={{backgroundColor: theme.palette.info.main,
                        width: 36, height: 36,
                        }}
                    >

                        <ArrowForward sx={{fill: '#fff'}}/>
                    </IconButton>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start',mt: 1}}>
                    <Typography sx={{fontSize: 16, fontWeight: 400, lineHeight: 1.2}}>
                        Programas prácticos diseñados para una empleabilidad rápida en sectores clave como tecnología,
                        administración, salud e industria
                    </Typography>
                </Grid>


            </Grid>


        </Grid>
    )

}
export default Tarjeta_Profundizaciones    